export const WHATS_NEW_UPDATES = [
  {
    id: 'botgo-video-2-5-launch',
    translationKey: 'botgoVideo25Launch',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/BotGo Video 2.5.mp4',
    posterSrc: '/images/whats-new/posters/botgo-video-2-5-launch.webp',
    tryNowHref: '/botgo-video/botgo-video-2-5',
    isNew: true,
  },
  {
    id: 'kling-4-0-launch',
    translationKey: 'kling40Launch',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Kling 4.0-v2.mp4',
    posterSrc: '/images/whats-new/posters/kling-4-0-launch-v2.webp',
    tryNowHref: '/kling/kling-4-0',
    isNew: true,
  },
  {
    id: 'nano-banana-2-1-launch',
    translationKey: 'nanoBanana21Launch',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Nano Banana 2.1.mp4',
    posterSrc: '/images/whats-new/posters/nano-banana-2-1-launch.webp',
    tryNowHref: '/nano-banana/nano-banana-2-1',
    isNew: true,
  },
  {
    id: 'botgo-image-2-5-flash-launch',
    translationKey: 'botgoImage25FlashLaunch',
    date: '2026-09-20',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/BotGo Image 2.5 Flash-v3.mp4',
    posterSrc: '/images/whats-new/posters/botgo-image-2-5-flash-launch-v3.webp',
    tryNowHref: '/botgo-image/botgo-image-2-5-flash',
    isNew: true,
  },
  {
    id: 'botgo-video-2-5-flash-launch',
    translationKey: 'botgoVideo25FlashLaunch',
    date: '2026-09-20',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/BotGo Video 2.5 Flash-v3.mp4',
    posterSrc: '/images/whats-new/posters/botgo-video-2-5-flash-launch-v3.webp',
    tryNowHref: '/botgo-video/botgo-video-2-5-flash',
    isNew: true,
  },
  {
    id: 'gpt-image-2-5-launch',
    translationKey: 'gptImage25Launch',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/GPT Image 2.5.mp4',
    posterSrc: '/images/whats-new/posters/gpt-image-2-5-launch.webp',
    tryNowHref: '/gpt-image/gpt-image-2-5',
    isNew: true,
  },
  {
    id: 'seedance-2-5-1080p-launch',
    translationKey: 'seedance251080pLaunch',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Seedance 2.5 1080P.mp4',
    posterSrc: '/images/whats-new/posters/seedance-2-5-1080p-launch.webp',
    tryNowHref: '/seedance/seedance-2-5?resolution=1080p',
    isNew: true,
  },
  {
    id: 'minimax-h3-max-launch',
    translationKey: 'minimaxH3MaxLaunch',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Minimax H3 Max.mp4',
    posterSrc: '/images/whats-new/posters/minimax-h3-max-launch.webp',
    tryNowHref: '/minimax/minimax-h3-max',
    isNew: true,
  },
  {
    id: 'wan-3-0-launch',
    translationKey: 'wan30Launch',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/WAN 3.0.mp4',
    posterSrc: '/images/whats-new/posters/wan-3-0-launch.webp',
    tryNowHref: '/wan/wan-3-0',
    isNew: true,
  },
  {
    id: 'gemini-omni-1-1-flash-launch',
    translationKey: 'geminiOmni11Launch',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Gemini Omni 1.1 Flash.mp4',
    posterSrc: '/images/whats-new/posters/gemini-omni-1-1-flash-launch.webp',
    tryNowHref: '/gemini-omni/omni-1-1-flash',
    isNew: true,
  },

  {
    id: 'seedance-2-5-launch',
    translationKey: 'seedance25Launch',
    date: '2026-08-07',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Seedance 2.5.mp4',
    posterSrc: '/images/whats-new/posters/seedance-2-5-launch.webp',
    tryNowHref: '/seedance/seedance-2-5',
    isNew: true,
  },
  {
    id: 'minimax-h3-launch',
    translationKey: 'minimaxH3Launch',
    date: '2026-07-31',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/MiniMax H3.mp4',
    posterSrc: '/images/whats-new/posters/minimax-h3-launch.webp',
    tryNowHref: '/minimax/minimax-h3',
    isNew: true,
  },
  {
    id: 'seedream-5.0-pro-launch',
    translationKey: 'seedream50ProLaunch',
    date: '2026-07-08',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Seedream 5.0 Pro.mp4',
    posterSrc: '/images/whats-new/posters/seedream-5.0-pro-launch.webp',
    tryNowHref: '/seedream/seedream-5-0-pro',
    isNew: true,
  },
  {
    id: 'nano-banana-lite-launch',
    translationKey: 'nanoBananaLiteLaunch',
    date: '2026-06-30',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Nano Banana Lite.mp4',
    posterSrc: '/images/whats-new/posters/nano-banana-lite-launch.webp',
    tryNowHref: '/nano-banana/nano-banana-2-lite',
    isNew: true,
  },
  {
    id: 'gemini-omni-flash-launch',
    translationKey: 'geminiOmniFlashLaunch',
    date: '2026-06-30',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Gemini Omni Flash.mp4',
    posterSrc: '/images/whats-new/posters/gemini-omni-flash-launch.webp',
    tryNowHref: '/gemini-omni/omni-flash',
    isNew: true,
  },
  {
    id: 'seedance-2-0-mini-launch',
    translationKey: 'seedance20MiniLaunch',
    date: '2026-06-23',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Seedance 2.0 Mini Is Here!.mp4',
    posterSrc: '/images/whats-new/posters/seedance-2-0-mini-launch.webp',
    tryNowHref: '/seedance/seedance-2-0-mini',
    isNew: true,
  },
  {
    id: 'seedance-2-0-4k-launch',
    translationKey: 'seedance204kLaunch',
    date: '2026-06-20',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Seedance 2.0 4K Live Now!.mp4',
    posterSrc: '/images/whats-new/posters/seedance-2-0-4k-launch.webp',
    tryNowHref: '/seedance/2.0',
    isNew: true,
  },
  {
    id: 'happyhorse-1-1-launch',
    translationKey: 'happyHorse11Launch',
    date: '2026-06-18',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Happy Horse 1.1 Live Now!.mp4',
    posterSrc: '/images/whats-new/posters/happyhorse-1-1-launch.webp',
    tryNowHref: '/happyhorse/happyhorse-1-1',
    isNew: true,
  },
  {
    id: 'grok-imagine-video-1-5-launch',
    translationKey: 'grokImagineVideo15Launch',
    date: '2026-06-16',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Grok Imagine Video 1.5 Is Here!.mp4',
    posterSrc: '/images/whats-new/posters/grok-imagine-video-1-5-launch.webp',
    tryNowHref: '/grok-imagine/grok-imagine-1-5',
    isNew: true,
  },
  {
    id: 'omni-flash-launch',
    translationKey: 'omniFlashLaunch',
    date: '2026-05-21',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Omni Flash Is Here!.mp4',
    posterSrc: '/images/whats-new/posters/omni-flash-launch.webp',
    tryNowHref: '/gemini-omni/omni-flash',
    isNew: true,
  },
  {
    id: 'happyhorse-1-0-launch',
    translationKey: 'happyHorse10Launch',
    date: '2026-04-28',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/HappyHorse 1.0 Is Live!.mp4',
    posterSrc: '/images/whats-new/posters/happyhorse-1-0-launch.webp',
    tryNowHref: '/happyhorse/happyhorse-1-0',
    isNew: true,
  },
  {
    id: 'gpt-image-2-launch',
    translationKey: 'gptImage2Launch',
    date: '2026-04-21',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/GPT Image 2 Now Live!.mp4',
    posterSrc: '/images/whats-new/posters/gpt-image-2-launch.webp',
    tryNowHref: '/gpt-image/gpt-image-2',
    isNew: true,
  },
  {
    id: 'seedance-2-0-launch',
    translationKey: 'seedance20Launch',
    highlightCount: 6,
    date: '2026-04-03',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Seedance 2.0 Is Here!.mp4',
    posterSrc: '/images/whats-new/posters/seedance-2-0-launch.webp',
    tryNowHref: '/seedance/2.0',
    isNew: true,
  },
  {
    id: 'kling-3-motion-control',
    translationKey: 'kling30MotionControl',
    date: '2026-03-05',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Kling 3.0 Motion Control is Now Live!.mp4',
    posterSrc: '/images/whats-new/posters/kling-3-motion-control.webp',
    tryNowHref: '/kling/kling-v3',
    isNew: true,
  },
  {
    id: 'nano-banana-2-launch',
    translationKey: 'nanoBanana2Launch',
    date: '2026-02-27',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Nano Banana 2 Is Here!.mp4',
    posterSrc: '/images/whats-new/posters/nano-banana-2-launch.webp',
    tryNowHref: '/nano-banana/nano-banana-2',
    isNew: true,
  },
  {
    id: 'kling-3-video-model',
    translationKey: 'kling30VideoModel',
    date: '2026-02-11',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Kling 3.0 Now Live!.mp4',
    posterSrc: '/images/whats-new/posters/kling-3-video-model.webp',
    tryNowHref: '/kling/kling-v3',
  },
  {
    id: 'grok-imagine-image',
    translationKey: 'grokImagineImage',
    date: '2026-02-06',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Grok Imagine Image Now Live!.mp4',
    posterSrc: '/images/whats-new/posters/grok-imagine-image.webp',
    tryNowHref: '/grok-imagine/grok-imagine-1-0',
  },
  {
    id: 'grok-imagine-video',
    translationKey: 'grokImagineVideo',
    date: '2026-02-05',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Grok Imagine Video is Here!.mp4',
    posterSrc: '/images/whats-new/posters/grok-imagine-video.webp',
    tryNowHref: '/grok-imagine/grok-imagine-1-0',
  },
  {
    id: 'veo-3-1-enhancements',
    translationKey: 'veo31Enhancements',
    date: '2026-01-19',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/New Enhancements in Veo 3.1.mp4',
    posterSrc: '/images/whats-new/posters/veo-3-1-enhancements.webp',
    tryNowHref: '/veo/veo-3-1',
  },
  {
    id: 'nano-banana-pro',
    translationKey: 'nanoBananaPro',
    date: '2025-11-20',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/Nano Banana Pro is Here!.mp4',
    posterSrc: '/images/whats-new/posters/nano-banana-pro.webp',
    tryNowHref: '/nano-banana/nano-banana-pro',
  },
  {
    id: 'veo-3-1-launch',
    translationKey: 'veo31Launch',
    date: '2025-10-16',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/veo-3-1-launch-50-off.mp4',
    posterSrc: '/images/whats-new/posters/veo-3-1-launch.webp',
    tryNowHref: '/veo/veo-3-1',
  },
  {
    id: 'sora-2-launch',
    translationKey: 'sora2Launch',
    date: '2025-09-24',
    mediaType: 'video',
    videoSrc: '/videos/whats-new/sora-2-launch-50-off.mp4',
    posterSrc: '/images/whats-new/posters/sora-2-launch.webp',
    tryNowHref: '/sora/sora-2',
  },
];

const WHATS_NEW_UPDATES_BY_ID = new Map(
  WHATS_NEW_UPDATES.map((update) => [update.id, update])
);

function normalizePath(pathname) {
  const cleanPath = String(pathname || '/').split(/[?#]/)[0] || '/';
  if (cleanPath === '/') return '/';
  return cleanPath.endsWith('/') ? cleanPath.slice(0, -1) : cleanPath;
}

export function getWhatsNewUpdateById(updateId) {
  return WHATS_NEW_UPDATES_BY_ID.get(updateId) || null;
}

export function getWhatsNewUpdatesByIds(updateIds = []) {
  return updateIds
    .map((updateId) => getWhatsNewUpdateById(updateId))
    .filter(Boolean);
}

export function getWhatsNewUpdateAcknowledgePaths(update) {
  if (!update) return [];

  const explicitPaths = Array.isArray(update.acknowledgePaths)
    ? update.acknowledgePaths
    : [];

  if (explicitPaths.length > 0) {
    return explicitPaths
      .map((path) => normalizePath(path))
      .filter((path) => path && path !== '/');
  }

  if (typeof update.tryNowHref === 'string' && update.tryNowHref.startsWith('/')) {
    const normalizedTryNowHref = normalizePath(update.tryNowHref);
    if (normalizedTryNowHref && normalizedTryNowHref !== '/') {
      return [normalizedTryNowHref];
    }
  }

  return [];
}

export function getWhatsNewAcknowledgePathsByIds(updateIds = []) {
  return Array.from(new Set(
    getWhatsNewUpdatesByIds(updateIds)
      .flatMap((update) => getWhatsNewUpdateAcknowledgePaths(update))
  ));
}
